var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalLinkImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 17,
    viewBox: "0 0 103.469 30.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_490",
    x: 0,
    y: 0,
    width: 103.469,
    height: 50.655,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2423",
    transform: "translate(-484.836 -838)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 484.84, 838)",
    filter: "url(#Path_490)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490-2",
    d: "M5.179,0H76.613a5.1,5.1,0,0,1,5.1,5.1V27.553a5.1,5.1,0,0,1-5.1,5.1H5.179a5.1,5.1,0,0,1-5.1-5.1v-7.24l-3.83-3.836,3.83-4.128V5.1A5.1,5.1,0,0,1,5.179,0Z",
    transform: "translate(12.75 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "question-square",
    transform: "translate(506.49 852.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    d: "M11.813,12.567h2.445A2.365,2.365,0,0,1,16.777,10a2.151,2.151,0,0,1,2.432,2.164c0,1.176-.693,1.717-1.787,2.54-1.246.906-2.234,1.964-2.164,3.681l.013.858h2.421v-.658c0-1.33.505-1.717,1.87-2.753,1.128-.858,2.3-1.81,2.3-3.808,0-2.8-2.364-4.151-4.951-4.151-2.457,0-5.161,1.2-5.1,4.692Zm2.893,10.218a1.745,1.745,0,0,0,1.87,1.717,1.737,1.737,0,1,0,0-3.459A1.742,1.742,0,0,0,14.706,22.784Z",
    transform: "translate(-11.813 -7.875)",
    fill: "#246898"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    cx: 3.663,
    cy: 3.663,
    rx: 3.663,
    ry: 3.663,
    transform: "translate(534.503 857.188)",
    fill: "#5d5b5b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    cx: 3.663,
    cy: 3.663,
    rx: 3.663,
    ry: 3.663,
    transform: "translate(549.156 857.188)",
    fill: "#5d5b5b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 3.663,
    cy: 3.663,
    rx: 3.663,
    ry: 3.663,
    transform: "translate(562.344 857.188)",
    fill: "#5d5b5b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_838",
    "data-name": "Line 838",
    y2: 25.512,
    transform: "translate(525.219 846.551)",
    fill: "none",
    stroke: "#5d5b5b",
    strokeWidth: 1,
    opacity: 0.731
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLinkImg);
export default __webpack_public_path__ + "static/media/modal-link-img.de335136c4a9a40b8f30d51a61c916bc.svg";
export { ForwardRef as ReactComponent };